export default __webpack_public_path__ + "static/media/icon-btc.306f9462.svg";